import endpoints from './endpoints';
import request from './request';

const companyApi = {
    list() {
        return request.get(
            endpoints.companies.list,
        );
    },

    get(companyId) {
        return request.get(
            endpoints.companies.show(companyId),
        );
    },

    create(data) {
        return request.post(
            endpoints.companies.create,
            data,
        );
    },

    update(companyId, data) {
        return request.put(
            endpoints.companies.update(companyId),
            data,
        );
    },

    remove(companyId) {
        return request.delete(
            endpoints.companies.remove(companyId),
        );
    },
};

export default companyApi;


// WEBPACK FOOTER //
// ./src/api/companyApi.js